import { render, staticRenderFns } from "./PurchaseExportToIsabel.vue?vue&type=template&id=03696be2&scoped=true"
import script from "./PurchaseExportToIsabel.vue?vue&type=script&lang=ts"
export * from "./PurchaseExportToIsabel.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseExportToIsabel.vue?vue&type=style&index=0&id=03696be2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03696be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03696be2')) {
      api.createRecord('03696be2', component.options)
    } else {
      api.reload('03696be2', component.options)
    }
    module.hot.accept("./PurchaseExportToIsabel.vue?vue&type=template&id=03696be2&scoped=true", function () {
      api.rerender('03696be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseExportToIsabel.vue"
export default component.exports